//---------------------------------------------------------
// Locked Linode-page certificate copy. Do not paraphrase.
//---------------------------------------------------------
import {canUseLinodeSettings} from './linodeUserKeys';

/**
 * Who sees the cert-expiry alerts on the Linode page. This is the only UI check.
 * Owner decision 2026-10-12: admin and operator, the same check as the #27
 * Linode page; viewer sees nothing. The OAM route's 403 stays the control.
 */
export function canSeeCertExpiryAlert(role: string | null | undefined): boolean {
	return canUseLinodeSettings(role);
}

export type CertExpirySide = 'server' | 'ca';
export type CertExpirySeverity = 'warning' | 'error';

export interface CertExpiryAlert {
	severity: CertExpirySeverity;
	text: string;
}

const SERVER_WITHIN_WINDOW =
	'The server certificate expires in {n} days. Renew it before then. Renewing it restarts the load balancer.';
const CA_WITHIN_WINDOW =
	'The CA expires in {n} days. Replacing it changes the load balancer and this console.';
const SERVER_EXPIRED =
	'The server certificate has expired. Renew it. Renewing it restarts the load balancer.';
const CA_EXPIRED = 'The CA has expired. Replacing it changes the load balancer and this console.';

function withDays(template: string, days: number): string {
	return template.replace('{n}', String(days));
}

/** One alert for one certificate. Null means the page shows nothing for that side. */
export function certExpiryAlert(side: CertExpirySide, days: number | null): CertExpiryAlert | null {
	if (days === null || days >= 30) return null;
	if (days <= 0) {
		return {severity: 'error', text: side === 'server' ? SERVER_EXPIRED : CA_EXPIRED};
	}
	return {
		severity: 'warning',
		text: withDays(side === 'server' ? SERVER_WITHIN_WINDOW : CA_WITHIN_WINDOW, days),
	};
}
